import { api } from "shared/config/api/api";
import { PROMO_URL } from "entities/wheel-raffle";
import type {
  JoinWheelRaffleRequest,
  JoinWheelRaffleResponse,
} from "entities/wheel-raffle";

export const joinWheelRaffleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Только для приватных; лимит 3 попытки в минуту.
    joinWheelRaffle: builder.mutation<
      JoinWheelRaffleResponse,
      JoinWheelRaffleRequest
    >({
      query: ({ raffleId, inviteCode }) => ({
        url: `${PROMO_URL}/wheel-raffles/${raffleId}/join`,
        method: "POST",
        body: { invite_code: inviteCode.trim() },
      }),
      // has_joined меняется в табло, поиске и детали.
      invalidatesTags: ["WheelRaffle"],
    }),
  }),
});

export const { useJoinWheelRaffleMutation } = joinWheelRaffleApi;
